import { useQuery } from '@tanstack/react-query';
import { get } from '@/lib/apiClient';

interface PublicCmsContent {
  id: string;
  slug: string;
  title: string;
  content: string;
  meta_title: string | null;
  meta_description: string | null;
  updated_at: string;
}

export function usePublicCmsContent(slug: string) {
  return useQuery({
    queryKey: ['cms-content', slug],
    queryFn: () => get<PublicCmsContent>(`cms/${slug}`),
    retry: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
